var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.util = leica.pi.util || {};

/*
 * eica.pi.util.conferenceInvite - object handles conference invitations 
 */
leica.pi.util.cConferenceInvite = function($)
{
    var self = {};
    self.inviteDivId = "_confInvite_";

    /**
     * Is the invitation dialog already open
     * @returns {Boolean}
     */
    self.inviteDialogIsOpen = function ()
    {
        return $("#" + this.inviteDivId).dialog("isOpen") === true;
    };
    
    /*
     * Show the conference invitation dialog
     * @param dscId The id of the conference (table DSC)
     * @param description The description of the conference typed in by the leader (table DSC)
     * @param dscInvitationId The id of the dsc invitation record (table DscInvitation, formerly called DscUser)
     * @param leaderName The name of the conference leader
     */
    self.presentConfInviteDialog = function(dscId, description, dscInvitationId, leaderName)
    {
        // TODO: Set this up so the dialog is created anew each time and loads the html dynamically as part of the dialog
        // Then destroy the dialog after user acknowledges it via OK or cancel
        
        // display invitation dialog
        $("<div>", {"id": "confInvite"}).load(leica.pi.util.conference.getDscInviteURL + ' .ResultsMain', function() {
            // setup the initial values of the dialog
            $(this).find('#dscInviteTextArea').val('');
            $(this).find('#dscInvitorName').text(leaderName);
            $(this).find('#dscDescription').text(null !== description ? description : '');  
        }).dialog({
                    autoOpen: true,
                    resizable: true,
                    dialogClass: 'confInviteDlg',
                    position: 'center',
                    height: 400,
                    width: 370,
                    title: 'Conference Invitation',
                    closeOnEscape: false,
                    buttons:
                            {
                                "Accept": function()
                                {
                                    var acceptMessage = $(this).find('#dscInviteTextArea').val();
                                    $(this).dialog('close');
                                    leica.pi.util.conference.joinConference(dscId, dscInvitationId, acceptMessage);                                    
                                },
                                "Decline": function() 
                                {
                                    var declineReason = $(this).find('#dscInviteTextArea').val();
                                    $(this).dialog('close');                                    
                                    leica.pi.util.conference.declineConference(dscInvitationId, declineReason);
                                }
                            },
                    open: function()
                    {                    
                        // hide the X in the dialog title bar.
                        $(".ui-dialog-titlebar-close").hide();
                    },
                    close: function()
                    {
                        $(this).dialog("destroy").remove();
                    }
                });
    };    
    
    /*
     * Close the conference invitation dialog
     */
    self.closeConfInviteDialog = function()
    {
        var dlg = $(".confInviteDlg");
        if (dlg.length > 0)
        {
            dlg.hide();
            dlg.dialog('close');
        }
    };
    
    return self;
    
};
// NetBeans navigator does not understand IIFEs. This is a workaround.
leica.pi.util.conferenceInvite = new leica.pi.util.cConferenceInvite(window.jQuery);